import React from 'react';
import { Link } from 'react-router-dom';
import '../Layout.css';

export default function UserMenu({ user, onLogout }) {
  return (
    <div className="user-menu">
      <div className="user-info">
        <span className="material-symbols-rounded">person</span>
        <span className="user-name">{user.name}</span>
      </div>
      <button onClick={onLogout} className="btn btn-text logout-btn" title="Logout">
        <span className="material-symbols-rounded">logout</span>
      </button>
    </div>
  );
}
